import { Text } from '@village/ui';

import * as Styled from './styles';

const PageHeader = () => (
    <Styled.Container>
        <Styled.Title type="h1">Book an Appointment</Styled.Title>
        <Text type="body2">In case of emergency or life threatening illness, call 911 or go to your local ER</Text>
    </Styled.Container>
);

export { PageHeader };
